// extracted by css-extract-rspack-plugin
export default {"number":"RiNvrNOQPcq6Yo9s","popover":"sFiXDhVgHnUXbHdX","popoverActions":"KzSUIOblfWQ9AbDW"};